import { render, staticRenderFns } from "./ExpertizeShemeList.vue?vue&type=template&id=482cae86&scoped=true&"
import script from "./ExpertizeShemeList.vue?vue&type=script&lang=js&"
export * from "./ExpertizeShemeList.vue?vue&type=script&lang=js&"
import style0 from "./ExpertizeShemeList.vue?vue&type=style&index=0&id=482cae86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482cae86",
  null
  
)

export default component.exports